import {
    ApiCompoundVehicleExportQueryParameter,
    ApiCompoundVehicleType,
} from '../../types/compoundManagement/queryParameterApi.types';
import { GetCompoundVehicleExportQueryParams } from '../../compoundManagementApi';
import { CompoundVehicleType } from '../../../sharedComponents/common.types';

export const mapToApiCompoundVehicleType = (compoundVehicleType: CompoundVehicleType): ApiCompoundVehicleType => {
    switch (compoundVehicleType) {
        case CompoundVehicleType.INCOMING:
            return ApiCompoundVehicleType.INCOMING;
        case CompoundVehicleType.IN_INVENTORY:
            return ApiCompoundVehicleType.IN_INVENTORY;
        case CompoundVehicleType.OUTGOING:
            return ApiCompoundVehicleType.OUTGOING;
        case CompoundVehicleType.DEPARTED:
            return ApiCompoundVehicleType.DEPARTED;
    }
};

export const mapToApiCompoundVehicleTypes = (
    compoundVehicleTypes: CompoundVehicleType[],
): ApiCompoundVehicleType[] | undefined => {
    if (compoundVehicleTypes.length === 0) {
        return undefined;
    }
    return compoundVehicleTypes.map((type) => mapToApiCompoundVehicleType(type));
};

export const mapToCompoundVehicleExportQueryParameters = (
    queryParameters: GetCompoundVehicleExportQueryParams,
): ApiCompoundVehicleExportQueryParameter => ({
    location: queryParameters.location,
    compound_vehicle_type:
        queryParameters.compoundVehicleTypes && mapToApiCompoundVehicleTypes(queryParameters.compoundVehicleTypes),
});
